import {
  isHotelProperty,
  isPureUltimate,
  isSiDaProperty,
  isStandard,
  isWeddingDressPhotoProperty,
  isWeddingPlanProperty
} from '@merchant-backend/util'
import { HLJ_STATISTIC } from '@util'
import cls from 'classnames'
import { inject } from 'mobx-react'
import React from 'react'
import { MARKETING } from '../constant'
import ImgChange from './imgChange'
import style from './index.module.less'

const statisticApp = key => {
  HLJ_STATISTIC({
    element_tag: key
  })
}

export default inject('pageStore')(props => {
  const { pageStore, forPro } = props
  const isWedding = isWeddingDressPhotoProperty() || isWeddingPlanProperty()
  const _isUltimate = isPureUltimate()
  const _isStandard = isStandard()
  const isSiDa = isSiDaProperty()
  const {
    COLLECT_ICON,
    SHARE_ICON,
    PROMISE_IMG,
    CONSULT_IMG,
    SKY_EYE_IMG,
    SHOP_SHOW_IMG,
    SHOP_SHOW_ICON
  } = pageStore.getPageConfig()
  let isHotel = isHotelProperty()
  return (
    <div className={style.marketing}>
      <div className="top">
        <div className="phone-common">
          <ImgChange forPro={forPro} />
        </div>
        {forPro &&
          isHotel && (
            <img
              className={cls('img-lunbo1')}
              src="//qnm.hunliji.com/FrvNfXc0m4qrNf9bOaWiPd6M1ROI"
            />
          )}
        {forPro &&
          isHotel && (
            <img
              className={cls('img-lunbo2')}
              src="//qnm.hunliji.com/FkgtgbJ7ixa5lsIMHDLkD8-EiilP"
            />
          )}
        {forPro &&
          isHotel && (
            <img
              className={cls('dianzhui1')}
              src="//qnm.hunliji.com/FjWfjiZJnP1M-aAxGxKxdKy6NnEO"
            />
          )}
        {forPro &&
          isHotel && (
            <img
              className={cls('dianzhui2')}
              src="//qnm.hunliji.com/FncOvhGSKSMoA0Wtcz-z1-E7Fsh6"
            />
          )}
        {forPro &&
          isHotel && (
            <img
              className={cls('dianzhui3')}
              src="//qnm.hunliji.com/FpjAbZD569XDr74JnVvwM9VqF2Mi"
            />
          )}
        {!forPro && (
          <div className="left phone-common">
            <img
              className={cls('img-theme')}
              id="img-theme"
              src="https://qnm.hunliji.com/o_1d4hnvciv16s5177nobq1h021mge9.png"
            />
            {!isSiDa && (
              <img
                className={cls('img-chengruo')}
                id="img-chengruo"
                src={PROMISE_IMG}
              />
            )}
            {!isSiDa && (
              <img
                className={cls('img-zixun')}
                id="img-zixun"
                src={CONSULT_IMG}
              />
            )}
            <ImgChange />
          </div>
        )}

        {!forPro && (
          <div className="right phone-common">
            <img
              className="right-img"
              src={SHOP_SHOW_IMG}
              style={{ maxWidth: isSiDaProperty() ? 'auto' : 360 }}
            />
            {!isSiDaProperty() && (
              <img
                className={cls('img-window')}
                id="img-window"
                src={SHOP_SHOW_ICON}
              />
            )}
          </div>
        )}
      </div>

      <div className="bottom">
        <h3 className="title">营销转化</h3>
        <p className="tip">多功能协同，让你的客源不断</p>
        <ul className="marketing-list">
          {MARKETING(forPro).map((item, index) => {
            if (
              !isWedding &&
              item.key == 'no_pro_marketing_potential_customers'
            ) {
              return null
            }
            let link = item.link
            if (_isUltimate) {
              link = item.openLink
            }
            if (_isStandard && item.key === 'no_pro_marketing_dedail_82') {
              link = item.openLink
            }
            if (
              item.key === 'no_pro_marketing_dedail_907' &&
              (_isUltimate || _isStandard)
            ) {
              link = item.openLink
            }
            let target = '_self'
            if (item.target && link === item.openLink) {
              target = item.target
            }
            return (
              <li key={index}>
                <a
                  href={link}
                  target={target}
                  onClick={() => statisticApp(item.key)}
                >
                  <img src={item.img} />
                  <p>{item.title}</p>
                </a>
              </li>
            )
          })}
        </ul>
        {isWedding ? (
          <div className="market-example clearfix">
            <div className="common fl">
              <img src="https://qnm.hunliji.com/o_1d42f7rni1aghcso1aagu3q19hj1c.png" />
              <div className="des">
                <h3>天眼系统</h3>
                <p>大数据分析用户行为，立即获取潜在客资</p>
              </div>
            </div>
            <img
              src="https://qnm.hunliji.com/o_1d4k5p45f11is1vgspgload17ff9.png"
              className="img-trans fl"
            />
            <div className="common fr">
              <img src="https://qnm.hunliji.com/o_1d42f9qro11mj179j1t4s1abg5kc1h.png" />
              <div className="des">
                <h3>潜在客资转化</h3>
                <p>潜在客资批量联系，高效转化</p>
              </div>
            </div>
          </div>
        ) : forPro && isHotel ? (
          <img
            className="img-yingxiaozhuanhua"
            src={'https://qnm.hunliji.com/FhIEoobixv_HbnmKaaaGhGFZhFZS'}
          />
        ) : (
          <img
            className="img-tianyan"
            src={
              isSiDaProperty()
                ? '//qnm.hunliji.com/o_1dn9iobh61q6cqnm1sa216g21rth9.png'
                : '//qnm.hunliji.com/o_1dlght74duos186d1m2c1nf1ani.png'
            }
          />
        )}

        {!forPro && (
          <div className="img-table-wrap">
            <img className="img-table" src={SKY_EYE_IMG} />
            <img className="img-shoucang-taocan" src={COLLECT_ICON} />
            <img className="img-zhuanfa-anli" src={SHARE_ICON} />
            <img
              className="img-guanzhu-dianpu"
              src="https://qnm.hunliji.com/o_1d4hq56md13qm1h69hj14p614bo1c.png"
            />
            <img
              className="img-lingquan-xingwei"
              src="https://qnm.hunliji.com/o_1d4hq5jot9ir1cje1g5m18d82kc1h.png"
            />
            <img
              className="img-piliang-zhuanfa"
              src="https://qnm.hunliji.com/o_1d4hq5vtf140op9lmq61eu3htt1m.png"
            />
          </div>
        )}
      </div>
    </div>
  )
})
